import React from 'react';
import styled from 'styled-components';


export const Navbody=styled.div`
width:100%;
height:10vh;
display:flex;

@media only screen and (min-width: 700px) {
    justify-content:center;
}
`
export const Navlisticons=styled.ul`
width:60%;
margin-top:0;
list-style-type:none;
height:80%;
padding:0;
display:flex;
justify-content:space-between;
align-items:end;

li{
text-align:center;
font-size:20px;
padding:10px;
color:white;
font-size:1.125rem;
cursor:pointer;
&:hover{
    text-shadow: 1.5px 1.5px 2px black;
}
}

a{
    color:white;
    text-decoration:none;
}

li:nth-child(3){
    color: white;
    font-family:cursive;
    font-weight: bold;
    font-size: 1.5rem;

    &:hover{
        text-shadow: 2px 2px 10px black;
        background: -webkit-linear-gradient(red, green);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}

@media only screen and (max-width: 700px) {
    width:100%;
    li{
        font-size:0.875rem;

    }
}
`

const Index = () => {
    return (
        <Navbody>
           <Navlisticons>
            <li><a href='#About'>About</a></li>
            <li><a href='#Work'>Work</a></li>
            <li>VG</li>
            <li><a href='#Skill'>Skill</a></li>
            <li><a href='#Contact'>Contact</a></li>
            </Navlisticons> 
        </Navbody>
    );
}

export default Index;
